module.exports = __webpack_public_path__ + "img/banner.d27631b9.png";